
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './button.component';
import { ButtonGrouppComponent } from './button-groupp.component';

export const COMPONENTS = [ ButtonGrouppComponent, ButtonComponent];


@NgModule({
  imports: [
    CommonModule
  ],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS]

})
export class ButtonModule { }
